import React, { useEffect } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { Alert, Pagination } from "@material-ui/lab";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import CustomBackdrop from "components/backdrop";
import { UltimaAtualizacao } from "components/ultimaAtualizacao";
import { ExportButtons } from "components/exportButtons";
import { StatCards } from "components/statCards";
import { SortDirectionSelect } from "components/sortDirectionSelect";
import { useConveniosState } from "./context/convenios-context";
import { useConveniosController } from "./context/convenios-controller";
import { ConveniosTable } from "./conveniosTable.component";

const formatCurrency = (value?: number) =>
  (value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export function ConveniosPage() {
  const { convenios, convenioPagedRequest, loading, situacoes, ultimaAtualizacao, totais, error } = useConveniosState();
  const { onInit, handleOnChange, listConvenios, exportConvenios } = useConveniosController();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await listConvenios({ ...convenioPagedRequest, page: value - 1 }, true);
    })();
  };

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Convênios" },
        ]}
      />
      <PageTitle>Convênios</PageTitle>
      <Wrapper>
        <StatCards
          items={[
            { label: "Valor Total Convênios", value: formatCurrency(totais?.valorTotalConvenio) },
            { label: "Valor Total Repassado", value: formatCurrency(totais?.valorTotalRepassado) },
          ]}
        />
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="text-field-term"
                  label="Número ou objeto"
                  value={convenioPagedRequest?.term || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Situação</InputLabel>
                  <Select
                    name="select-situacao-id"
                    value={convenioPagedRequest?.idSituacaoConvenio || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Situação"
                    displayEmpty
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {situacoes?.map((s) => (
                      <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <SortDirectionSelect
                  value={convenioPagedRequest?.orderDirection}
                  onChange={(e) => handleOnChange(e)}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <SearchButton onClick={() => (async () => {
                  await listConvenios(convenioPagedRequest, true);
                })()}>
                  <SearchIcon /> Consultar
                </SearchButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <UltimaAtualizacao data={ultimaAtualizacao} />
            <ExportButtons onExport={exportConvenios} />
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <ConveniosTable currentItems={convenios} />
            )}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3} justifyContent="center">
              <Pagination
                size="large"
                variant="outlined"
                shape="rounded"
                onChange={handlePageClick}
                count={convenios?.pageCount}
                color="primary"
              />
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}
